var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BankCardInfoPop"},[_c('div',{staticClass:"cardBorder"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('lang.UPIandBankCardInfo.UPIInfo')))])])]),_vm._v(" "),_c('img',{staticClass:"close",attrs:{"src":require("../../assets/images/accountInfo/close.png"),"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c91b876","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BankCardInfoPop/index.vue
// module id = null
// module chunks = 